/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import BTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import "react-datetime/css/react-datetime.css";
import { useTable } from "react-table";
import "./Users.css";
import { epochToDate } from "../../dateutils";
import { httpClient } from "../../request";
import { statusToIcon } from "../../status";

/**
 * @todo Support pagination
 *
 * @param {*} param0
 */
function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  // Render the UI for your table
  return (
    <BTable striped bordered hover size="sm" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </BTable>
  );
}

export default function Licenses() {
  const [isLoading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [result, setResult] = useState(false);
  const [appIDIndex, setAppIDIndex] = useState(-1);

  const [createShow, setCreateShow] = useState(false);

  const [createData, setCreateData] = useState({
    plan: 0,
    length: 0,
    amount: 1,
  });

  const handleCreateChange = (e) => {
    const { id, value } = e.target;
    setCreateData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCreateClose = () => setCreateShow(false);
  const handleCreateShow = () => setCreateShow(true);

  const token = JSON.parse(localStorage.getItem("token"));

  const getLicenses = (appID) => {
    httpClient
      .get(`/private/licenses?app=${appID}`, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        let licensesForApp = responseData.licenses;
        for (let i = 0; i < licensesForApp.length; ++i) {
          licensesForApp[i].app = appID;
        }

        setLicenses(licensesForApp);

        setLoading(false);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const handleChangeAppID = (e) => {
    const { id, value } = e.target;
    setAppIDIndex(value);

    getLicenses(apps[value].PublicId);
  };

  const getApps = () => {
    httpClient
      .get("/private/apps", {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        setApps(responseData.apps ? responseData.apps : []);

        setLoading(false);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const deleteLicense = (license, appID) => {
    httpClient
      .delete(`/private/licenses?app=${appID}&license=${license}`, {
        headers: {
          Authorization: `Bearer ${token.token}`,
        },
      })
      .then((response) => {
        setResult({
          status: "success",
          message: "Deleted license",
        });

        // Reload the users since our data changed
        getLicenses(appID);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const createLicense = () => {
    httpClient
      .post(`/private/licenses?app=${apps[appIDIndex].PublicId}`, null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
        params: createData,
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: "Successfully created new license(s)",
          });
          getLicenses(apps[appIDIndex].PublicId);
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    setCreateShow(false);
  };

  // useEffect tells the component that it must do something after it has rendered
  useEffect(() => getApps(), []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Licenses",
        columns: [
          {
            Header: "License",
            accessor: "License",
          },
          {
            Header: "Generated At",
            accessor: (d) => {
              return d.GeneratedAt
                ? epochToDate(d.GeneratedAt).toISOString()
                : "N/A";
            },
          },
          {
            Header: "Used",
            accessor: (d) => {
              return d.Used ? "Yes" : "No";
            },
          },
          {
            Header: "Used at",
            accessor: (d) => {
              return d.UsedAt
                ? epochToDate(d.UsedAt).toISOString()
                : "N/A";
            },
          },
          {
            Header: "Used By",
            accessor: "UsedBy",
          },
          {
            id: "del",
            Header: "",
            accessor: (d) => {
              return d;
            },
            Cell: ({ value }) => (
              <Button
                variant="danger"
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you want to delete this license?"
                    )
                  )
                    deleteLicense(value.License, value.app);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="Licenses">
      <div className="mt-5">
        {result && (
          <Alert variant={result.status}>
            <span className="mr-1">
              <FontAwesomeIcon icon={statusToIcon[result.status]} />
            </span>
            <span>{result.message}</span>
          </Alert>
        )}

        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div>
            <Form>
              <Form.Group controlId="appID">
                <Form.Label>App ID</Form.Label>
                <Form.Control
                  as="select"
                  onChange={handleChangeAppID}
                  defaultValue={`DEFAULT`}
                >
                  <option value="DEFAULT" disabled>
                    Select an app ID...
                  </option>
                  {apps.map((c, i) => {
                    return (
                      <option key={c.PublicId} value={i}>
                        {c.PublicId}
                      </option>
                    );
                  })}
                </Form.Control>
                <small className="form-text text-muted">
                  Select an app to show its API keys
                </small>
              </Form.Group>
            </Form>

            <div>
              {appIDIndex >= 0 && (
                <div>
                  <Table columns={columns} data={licenses} />
                  {licenses.length === 0 && (
                    <p className="text-center">No data available</p>
                  )}
                </div>
              )}
            </div>

            <div className="float-right">
              <Button variant="success" onClick={handleCreateShow}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>

            <Modal show={createShow} onHide={handleCreateClose}>
              <Modal.Header closeButton>
                <Modal.Title>Add license</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group controlId="plan">
                    <Form.Label>Plan</Form.Label>
                    <Form.Control
                      type="text"
                      value={createData.plan}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="length">
                    <Form.Label>Valid For</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={handleCreateChange}
                      defaultValue={`DEFAULT`}
                    >
                      <option value="DEFAULT" disabled>
                        Select a validity length...
                      </option>
                      <option value="1800">30 minutes</option>
                      <option value="3600">1 hour</option>
                      <option value="21600">6 hours</option>
                      <option value="43200">12 hours</option>
                      <option value="86400">1 day</option>
                      <option value="259200">3 days</option>
                      <option value="604800">1 week</option>
                      <option value="604800">1 week</option>
                      <option value="2628288">1 month</option>
                      <option value="7884864">3 months</option>
                      <option value="15769728">6 months</option>
                      <option value="31536000">1 year</option>
                      <option value="3153600000">Lifetime</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="amount">
                    <Form.Label>Amount of licenses</Form.Label>
                    <Form.Control
                      type="text"
                      value={createData.amount}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleCreateClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={createLicense}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/Licenses.js